import React from 'react';
import {Row, Col} from 'react-bootstrap';

const CustomPagination = ({activePage, onBack, onForward, listLength}) => {
  return(
    <Row className="class-pagination">
      <Col md={2}>
        {activePage > 1 ?
          <span onClick={()=> {onBack()}}><i className="fa fa-angle-left"></i> Page {activePage -1}</span>
          : null}
      </Col>
      <Col md={8} className="text-center">
        Page {activePage} of {listLength}
      </Col>
      <Col md={2} className="text-right">
        {activePage < listLength ?
          <span onClick={()=> {onForward()}}>Page {activePage +1} <i className="fa fa-angle-right"></i></span>
          : null }
      </Col>
    </Row>
  )
};

export default CustomPagination;



// WEBPACK FOOTER //
// ./src/components/common/CustomPagination.js